import React from "react";
import "./InvestmentHeader.css";
import { useUser } from "../../../../../hooks/use-user";

const InvestmentHeader = () => {
  const user = useUser();
  const { lastname } = user;

  return (
    <div className="investmentHeader">
      <h5 className="investmentHeader-title">Investment</h5>
      <p className="investmentHeader-p">
        Hi {lastname}, let’s see how far you’ve invested.
      </p>
    </div>
  );
};

export default InvestmentHeader;
